// extracted by mini-css-extract-plugin
export default {"wrapper":"Comments_wrapper__7avPi","textarea":"Comments_textarea__w3u8e"};